export const LOGIN_START = "LOGIN_START"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_RESET = "LOGIN_RESET";
export const LOGIN_STATUS = "LOGIN_STATUS";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGIN_VERIFY = "LOGIN_VERIFY";
export const LOGOUT = "LOGOUT";
export const LOGOUT_START = "LOGOUT_START";
export const LOGIN_REVALIDATE = "LOGIN_REVALIDATE";

export const SET_STRUCTURE = "SET_STRUCTURE";